import {
  addMinutes,
  subMinutes,
  differenceInMilliseconds,
  isPast,
  isWithinInterval,
} from 'date-fns';
import { disableFullScreen } from './video';
import Logger from 'src/utils/logger';
import Misc from 'src/utils/misc';
import * as Sentry from '@sentry/browser';
import API from './api';

let currentUserId;
let currentVid;
let modal;
let modalTimeout;
let verifyBtn;

/**
 * Funzione che imposta i check per la verifica delle presenze.
 */
const setTimeoutChecks = () => {
  const now = new Date();
  const verifyTimes = Misc.getVerifyTimes(now);
  Logger('debug', `scheduled checks are ${verifyTimes}`);
  Logger('debug', verifyTimes);
  Object.keys(verifyTimes).forEach((vid) => {
    if (!isPast(verifyTimes[vid])) {
      const diffInMilliseconds = differenceInMilliseconds(
        verifyTimes[vid],
        now.getTime(),
      );
      setTimeout(() => {
        showModal(vid, verifyTimes[vid]);
      }, diffInMilliseconds);
    }
  });
  Logger('debug', 'Timeout checks enabled.');
};

/**
 * Fa apparire la modale.
 */
const showModal = (vid, checkDate) => {
  const currentTime = new Date();
  const infOffsetTime = subMinutes(checkDate, 1);
  const supOffsetTime = addMinutes(checkDate, 2);
  /**
   * Questo check serve ad evitare l'apparizione modale
   * su Safari Mobile che triggera eventi che dovrebbero essere
   * expired quando si mette in evidenza la pagina (ad esempio cambio tag oppure uscendo dalla sospensione).
   *
   * Dato che il trigger non parte nell'esatto momento indicato dal check,
   * ma può partire qualche millisecondo prima o dopo, devo prevedere
   * un intervallo tra 1 min prima e 2 min dopo il tempo del check.
   *
   * Quest'ultima accortezza garantisce che la modale appaia quando la pagina è in evidenza.
   */
  const isWithinTwoMinutes = isWithinInterval(currentTime, {
    start: infOffsetTime,
    end: supOffsetTime,
  });
  if (!modal || !isWithinTwoMinutes) {
    Logger(
      'debug',
      `modal not showed for check ${vid} because modal does not exists or check not within two minutes interval`,
    );
    Logger('debug', `current time: ${currentTime}`);
    Logger('debug', `check trigger time: ${checkDate}`);
    return;
  }
  Logger('debug', `showing modal for check ${vid}`);
  Sentry.addBreadcrumb({
    category: 'analytics',
    message: `enabled modal for check ${vid}`,
    level: 'info',
  });
  // tolgo il fullscreen se presente.
  disableFullScreen();
  currentVid = vid;
  modal.classList.add('show');
  // Imposto la chiusura della modale in un minuto:
  modalTimeout = setTimeout(hideModal, 1000 * 60);
};

/**
 * Chiude la modale.
 */
const hideModal = () => {
  if (!modal) {
    return;
  }
  modal.classList.remove('show');
  Logger('debug', 'closing modal...');
  Sentry.addBreadcrumb({
    category: 'analytics',
    message: 'closing modal...',
    level: 'info',
  });
  clearTimeout(modalTimeout);
};

/**
 * Invia al server il check utente.
 */
const sendVerify = async () => {
  try {
    verifyBtn.disabled = true;
    await API.confirmPresence(currentUserId, currentVid);
  } catch (error) {
    console.error(error.message);
  } finally {
    verifyBtn.disabled = false;
    hideModal();
  }
};

/**
 * Inizializza il modulo.
 */
const init = (userId) => {
  currentUserId = userId;
  modal = document.querySelector('.check__modal');
  if (modal) {
    verifyBtn = modal.querySelector('button.btn');
    if (verifyBtn) {
      verifyBtn.addEventListener('click', sendVerify);
    }
  }
  setTimeoutChecks();
};

// Espongo le funzioni se sono in dev
if (process.env.STAGE === 'dev') {
  window.showModal = showModal;
  window.hideModal = hideModal;
}

export default { init };
